//////////////////////////////////////////////////////////////////////////////////////   IMPORT
///////////////////////////////////////////////////////////   REACT
import React from 'react';
///////////////////////////////////////////////////////////   LIBS
import Button from 'react-bootstrap/Button';
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import ButtonToolbar from 'react-bootstrap/ButtonToolbar';
import Col from 'react-bootstrap/Col';
import Ratio from 'react-bootstrap/Ratio';
import Row from 'react-bootstrap/Row';
import { decode } from 'html-entities';
///////////////////////////////////////////////////////////   SETTINGS
import { _SETTINGS } from 'config/settings';
// import videojsConfig from '../../../config/videojs-config/config';
///////////////////////////////////////////////////////////   ASSETES
import { getFrameNum, millToTimecode } from '../../../assets/js/video-methods';
///////////////////////////////////////////////////////////   COMPS
import FrameList from '../framelist/framelist.component';
import VideoPlayer from '../videojs-video-player/video-player.component';
import SpritePreset from '../videojs-video-player/sprite-preset.component';
import PeakMeter from '../videojs-video-player/video-player-peakmeter';

///////////////////////////////////////////////////////////   SCSS
import './main-video.styles.scss';

///////////////////////////////////////////////////////////   FONTAWESOME
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { faBorderStyle, faFilm, faStopwatch, faTheaterMasks, faChartBar } from '@fortawesome/free-solid-svg-icons';
import { isConstructorDeclaration } from 'typescript';



///////////////////////////////////////////////////////////   INTERFACE
interface programObject {
  [key: string]: any;
}
//////////////////////////////////////////////////////////////////////////////////////    CLASS SETUP
class MainVideo extends React.Component<any, { [key: string]: any }> {
  private vp: React.RefObject<VideoPlayer>;
  constructor(props: any) {
    super(props);
    this.state = {
      ...props,
      showTc: this.props.showTimeCode,
      showFrame: this.props.showFrameCode,
      localAm: localStorage.getItem('localAm'),
      loadAm: this.props.enableAudioMonitor,
      startAudioMonitor: true,
      wh: window.innerHeight,
      ww: window.innerWidth,
      showTitleSafeArea: this.props.showTitleSafe,
      _sideNavSelStage: 'sideNav_videoPlayer',
      theaterMode: false
    };
    this.vp = React.createRef();

  }
  ///////////////////////////////////////////////////////////   LIFECYCLE METHODS
  componentDidMount() {
    const item = document.getElementsByClassName('vjs-audio-button')[1];
    item?.addEventListener('mouseover', this.changeAudioTrackTitles, false);
    console.log(this.props);
  }



  componentDidUpdate(prevProps: any) {
    if (this.props !== prevProps) {
      this.setState({ ...this.props }, () => {
        let { mainVideo } = this.state;
        this.refreshPlayer(mainVideo);
      });
    }
    if (this.props.playerType !== prevProps.playerType) {
      this.setState({ playerType: this.props.playerType });
    }


  }
  componentWillUnmount() {
    const { _timeCodeInterval } = this.state;
    let player = this.vp.current?.player;
    this.timeCode();
    if (player) player.dispose();
    this.setState({ _timeCode: null, _frameCode: null, _timeCodeInterval: null });
    clearInterval(_timeCodeInterval);
  }
  ///////////////////////////////////////////////////////////   CLASS METHODS
  /////////////////////////////////////   VIDEO
  /**
   * Show timecode on video
   */
  private showTc = (): void => {
    this.setState({ showTc: !this.state.showTc });
  };
  /**
   * Show framecode on video
   */
  private showFrame = (): void => {
    this.setState({ showFrame: !this.state.showFrame });
  };
  /**
   * Show titlesafe area on video
   */
  private showTitleSafe = (): void => {
    this.setState({ showTitleSafeArea: !this.state.showTitleSafeArea });
    console.log(this.state.showTitleSafeArea);
  };

  /**
   * Timecode
   * Update state of timecode
   */
  private timeCode = (): void => {
    let player = this.vp.current?.player;
    if (player && player.currentTime()) {
      this.setState({ _timeCode: millToTimecode(player.currentTime()), _frameCode: getFrameNum(player.currentTime()) });
    }
  };
  /**
   * Show Audio Monitor on video
   */
  private setAm = () => {
    let ertek;
    this.state.showAm ? ertek = 'false' : ertek = 'true';
    localStorage.setItem('localAm', ertek.toString());
    this.setState({ showAm: !this.state.showAm });
  };

  private setPlay = () => {
    this.setState({ startAudioMonitor: true })

  };

  private setPause = () => {
    this.setState({ startAudioMonitor: false })
  };

  private setAmByLocal = () => {
    if (this.state.localAm) {

      if (this.state.localAm == "true") {

        this.setState({ showAm: true });
      }
      else if (this.state.localAm == "false") {
        this.setState({ showAm: false });
      }

    } else {
      this.setState({ showAm: this.state.showAm })
    }

  }

  /**
   * Jump to startframe
   * @param frNum
   */
  private handleJumpToStartFrame = (frNum: number): void => {
    let player = this.vp.current?.player;
    if (frNum && frNum > 1) {
      setTimeout(() => {
        player.pause();
        let now = frNum / _SETTINGS.basic.frameRate - 1 / _SETTINGS.basic.frameRate;
        player.pause();
        player.currentTime(now, 'seconds');
      }, 200);
    }
  };


  private jumpToStart = () => {
    let player = this.vp.current?.player;
    player.pause();
    setTimeout(() => {
      player.currentTime(0);
    }, 200);
  }


  private jumpToEnd = () => {
    let player = this.vp.current?.player;
    setTimeout(() => {
      player.pause();
      player.currentTime(player.duration());
    }, 200);
  }
  /**
   * Setup player
   * Setup features like: volume, muted etc.
   */
  private onPlayerReady = (): void => {
    let player = this.vp.current?.player;
    const { muted, volume, playerType, startFrame, mainVideo, autoplay } = this.state;

    // Volume
    player.muted(muted);
    let vol = localStorage.getItem('volumer');
    vol ? player.volume(vol) : player.volume(volume);

    // Frame
    if (startFrame && startFrame > 0) {
      this.handleJumpToStartFrame(startFrame);
    }

    // Type
    if (playerType !== _SETTINGS.playerType.embed && autoplay !== false) {
      setTimeout(() => {
        player?.play();
      }, 300);
    }

    // Vtt
    if (mainVideo.textTracks) {
      mainVideo.textTracks.forEach((track: any) => {
        player.addRemoteTextTrack(track, false);
      });
    }

    // Tc
    this.setState({ _timeCodeInterval: setInterval(() => this.timeCode(), _SETTINGS.basic.frameRate) });

    // Set up sprites
    if (mainVideo.preview && mainVideo.preview.isPreRenderedThumbSet && player) {
      SpritePreset(player, {
        url: mainVideo.preview.preRenderedThumbUrl,
        width: mainVideo.preview.preRenderedThumbWidth,
        height: mainVideo.preview.preRenderedThumbHeight,
        interval: mainVideo.preview.preRenderedThumbInterval,
        responsive: 0,
        showImgSrc: false,
        isPreRenderedThumbSet: mainVideo.preview.isPreRenderedThumbSet
      });
    }

    this.setAmByLocal();

  };

  /**
   * On video play
   */
  private onVideoPlay = (): void => {
    let player = this.vp.current?.player;
    if (player.duration() === player.currentTime()) {
      player.currentTime(0);
      player.play();
    }
    this.setPlay();
  };

  /**
   * On video pause
   * When video pauses frame correction needed
   */
  private onVideoPause = (): void => {
    let player = this.vp.current?.player;
    if (player.duration() !== player.currentTime()) {
      setTimeout(() => {
        player.currentTime(player.currentTime() - 1 / _SETTINGS.basic.frameRate);
        player.currentTime(player.currentTime() + 2 / _SETTINGS.basic.frameRate);
      }, 125);
    }
    this.setPause();
  };

  /**
   * On video seeked
   */
  private onVideoSeeked = (): void => {
    let player = this.vp.current?.player;
    if (player.currentTime() < 1 / 2) {
      this.setState({
        _timeCode: '00:00:00:00',
        _frameCode: '0'
      });
    }
  };

  /**
   * Change current frame
   * @param i time
   */
  private changeCurrentFrame = (i: number): void => {
    try {
      let player = this.vp.current?.player;
      player.pause();
      player.currentTime(player.currentTime() + i / _SETTINGS.basic.frameRate, 'seconds');
    } catch (e) {
      console.error(e);
    }
  };

  /**
   * Refresh / update player
   * @param data
   */
  private refreshPlayer = (data: programObject): void => {
    let player = this.vp.current?.player;
    if (player) {
      this.setState({
        _isPreloading: false,
        _isPreloaded: false,
        cleanSrc: this.getCleanUrl(data),
        _audioTracks: null,
        _showAudioTracks: false,
        _snapTimesArr: [],
        mainVideo: data,
        isPreRenderedThumbSet: false
      });

      this.loadUniqueUrl(data);
      let times: HTMLCollectionOf<Element> | any = document.getElementsByClassName('vjs-time-tooltip'),
        img: any = document.getElementById('temporarityImg'),
        oldTracks = player.remoteTextTracks(),
        i = oldTracks.length;
      img.src = null;
      if (times && times[0]) times[0].style = {};
      if (data.hasOwnProperty('preview')) {
        if (data.preview.preRenderedThumbInterval !== 0 || data.preview.preRenderedThumbUrl !== '') {
          if (times && times[0]) times[0].style.display = 'block';
          SpritePreset(player, {
            url: data.preview.preRenderedThumbUrl,
            width: data.preview.preRenderedThumbWidth,
            height: data.preview.preRenderedThumbHeight,
            interval: data.preview.preRenderedThumbInterval,
            responsive: 0,
            showImgSrc: false,
            isPreRenderedThumbSet: data.preview.isPreRenderedThumbSet
          });
        }
      }
      player.removeRemoteTextTrack();
      while (i--) {
        player.removeRemoteTextTrack(oldTracks[i]);
      }
      if (data.hasOwnProperty('textTracks')) {
        data.textTracks.forEach((track: any) => {
          player.addRemoteTextTrack(track, false);
        });
      }
      let audioTrackList = player.audioTracks(),
        audioTracks = audioTrackList.tracks_;
      if (audioTracks.length <= 1) {
        this.setState({ _showAudioTracks: false });
      }
    }
  };
  /**
   *  Get clean url
   * @param programData
   * @returns url
   */
  private getCleanUrl = (programData: programObject): string | null => {
    let url = null;
    if (programData && programData.program instanceof Array) {
      programData.program.forEach((v: programObject, k: number) => {
        if (v.id === 'url') {
          url = v.data.replace('#', '');
        }
      });
    }
    return url;
  };
  /**
   * Load unique url
   */
  private loadUniqueUrl = (data: any): void => {
    let player = this.vp.current?.player,
      urlInfo = null;
    data instanceof Object ? (urlInfo = this.getCleanUrl(data)) : (urlInfo = data);
    this.setState({ urlInfo: urlInfo, cleanSrc: urlInfo });
    player.src(urlInfo);
  };

  /////////////////////////////////////   AUDIO
  /**
   * Change audio tract titles
   */
  private changeAudioTrackTitles = (): void => {
    let player = this.vp.current?.player;
    const elements = [...Array.from(document.querySelectorAll('.vjs-audio-button .vjs-menu-content .vjs-main-menu-item'))],
      audioTrackList = player.audioTracks(),
      audioTracks = audioTrackList.tracks_;
    elements.forEach((elm) => {
      (elm as HTMLElement).style.visibility = 'hidden';
    });
    setTimeout(() => {
      const audioTitleList = [...Array.from(document.querySelectorAll('.vjs-audio-button .vjs-menu-content .vjs-main-menu-item'))];
      if (audioTitleList.length) {
        audioTitleList.forEach((aud, k) => {
          (aud as HTMLElement).textContent = this.fixAudioLabels(audioTracks[k]);
          (aud as HTMLElement).style.visibility = 'visible';
          (aud as HTMLElement).addEventListener('click', (e) => this.handleAudioTrack(k, e), true);
        });
      }
    }, 75);
  };

  /**
   * Handle audio track
   * @param track
   * @param e
   */
  private handleAudioTrack = (track: any, e: any): void => {
    let player = this.vp.current?.player;
    const audioTrackList = player.audioTracks(),
      aTracks = audioTrackList.tracks_,
      actTime = player.currentTime();
    player.pause();
    for (let i = 0; i < aTracks.length; i++) {
      if (i !== track) {
        aTracks[i].enabled = false;
      }
    }
    aTracks[track].enabled = true;
    player.currentTime(parseFloat(actTime));
    setTimeout(() => {
      player.play();
    }, 100);
  };

  /**
   * Fix audio labels
   * This method filters and fixes audio labels
   * @param audioSrc
   * @returns string
   */
  private fixAudioLabels = (audioSrc: any): string => {
    const LANG = {
      hu: 'magyar',
      en: 'angol',
      de: 'német',
      or: 'eredeti',
      st: 'sztereó'
    },
      search = [
        {
          display: LANG.hu,
          keyWords: ['hu', 'hun', 'magyar', 'hungarian', 'ungarn']
        },
        {
          display: LANG.en,
          keyWords: ['en', 'eng', 'english', 'englisch']
        },
        {
          display: LANG.de,
          keyWords: ['de', 'deutsch', 'ger', 'german']
        },
        {
          display: LANG.or,
          keyWords: ['log', 'orig', 'original', 'mix']
        },
        { display: LANG.st, keyWords: ['stereo'] } // stb.
      ],
      result = search.filter((val) => val.keyWords.includes(audioSrc.language))[0];
    return result ? result.display : LANG.or;
  };
  toggleTheater = () => this.setState({ theaterMode: !this.state.theaterMode });
  ///////////////////////////////////////////////////////////   RENDER

  render() {
    const { cleanSrc, autoplay, showTc, showAm, loadAm, showFrame, startAudioMonitor, _frameCode, _timeCode, playerType, frameList, showTitleSafeArea, theaterMode } = this.state;

    return (
      <>
        <div className={theaterMode ? 'all-video-container theater' : 'all-video-container '}>
          <Col className={playerType === _SETTINGS.playerType.embed ? 'd-flex embed video-holder' : 'd-flex standard video-holder'} xs={12} xl={playerType === _SETTINGS.playerType.embed ? 12 : theaterMode ? 12 : 12}>

            <Ratio aspectRatio='16x9'>

              {cleanSrc ? (
                <>

                  <VideoPlayer width={'100vw'} height={'100vh'} src={cleanSrc} bigPlayButton={playerType === _SETTINGS.playerType.embed ? true : true} bigPlayButtonCentered={playerType === _SETTINGS.playerType.embed ? true : true} autoplay={autoplay} onReady={this.onPlayerReady.bind(this)} onPlay={this.onVideoPlay.bind(this)} onPause={this.onVideoPause.bind(this)} seekbar={true} onSeeked={this.onVideoSeeked.bind(this)} language={'hu'} ref={this.vp} />



                  <div className='titleSafe'>
                    {showTitleSafeArea ? (
                      <>
                        <div className='aspectRatioImg'>{showTitleSafeArea}</div>
                        <div className='aspectRatioTxt'>{showTitleSafeArea}</div>
                      </>
                    ) : null}
                  </div>
                  <div className='d-flex justify-content-center tc'>{playerType !== _SETTINGS.playerType.embed && showTc && <span>{_timeCode ? _timeCode : '00:00:00:00'}</span>}</div>
                  <div className='d-flex justify-content-end frames'>{playerType !== _SETTINGS.playerType.embed && showFrame && <span>{_frameCode}</span>}</div>
                </>
              ) : (
                'betöltés'
              )}

            </Ratio>


            {playerType === _SETTINGS.playerType.embed || !loadAm ? null : <PeakMeter show={showAm} play={startAudioMonitor}></PeakMeter>}


          </Col>
          <Col xs={12} xl={12} className='mb-3'>
            {playerType !== _SETTINGS.playerType.embed ? (
              <ButtonToolbar className='toolbarMenu' aria-label='Toolbar with button groups'>
                <Row>
                  <Col md={6} lg={7} sm={12} className='text-md-start text-center'>
                    <ButtonGroup aria-label='First group' className='first-group' size='sm'>
                      <Button title='Az elejére' className={'rounded-0'} variant='secondary' onClick={this.jumpToStart}><span className='player-arrow-icons'><FontAwesomeIcon icon={'caret-left'} /></span></Button>
                      <FrameList frameList={frameList} handleFrames={this.changeCurrentFrame} />
                      <Button title='A végére' className={'rounded-0'} variant='secondary' onClick={this.jumpToEnd}><span className='player-arrow-icons'><FontAwesomeIcon icon={'caret-right'} /></span></Button>
                    </ButtonGroup>
                  </Col>
                  <Col md={12} lg={4} className='mx-auto d-sm-none'></Col>
                  <Col md={6} lg={5} sm={12} className='text-md-end text-center'>
                    <ButtonGroup aria-label='Second group' className='float-md-end float-lg-end'>
                      <Button onClick={this.toggleTheater} className={theaterMode ? 'rounded-0 btn-active' : 'rounded-0'} size='sm' variant='secondary' title='Theater Mode'>
                        <span className='player_icon'>
                          <FontAwesomeIcon icon="theater-masks" />
                        </span>
                        TM
                      </Button>
                      <Button onClick={this.showTitleSafe} className={showTitleSafeArea ? 'btn-active rounded-0' : 'rounded-0'} size='sm' variant='secondary' title='Title Safe Area'>
                        <span className='player_icon'>
                          <FontAwesomeIcon icon="border-style" />
                        </span>
                        TS
                      </Button>

                      <Button onClick={this.showTc} className={showTc ? 'btn-active rounded-0' : 'rounded-0'} size='sm' variant='secondary' title='TimeCode'>
                        <span className='player_icon'>
                          <FontAwesomeIcon icon="stopwatch" />
                        </span>
                        TC
                      </Button>
                      <Button onClick={this.showFrame} className={showFrame ? 'btn-active rounded-0' : 'rounded-0'} size='sm' variant='secondary' title='Frame'>
                        <span className='player_icon'>
                          <FontAwesomeIcon icon="film" />
                        </span>
                        FR
                      </Button>
                      {loadAm &&
                        <Button onClick={this.setAm} className={showAm ? 'btn-active rounded-0' : 'rounded-0'} size='sm' variant='secondary' title='Audio Monitor'>
                          <span className='player_icon'>
                            <FontAwesomeIcon icon="chart-bar" />
                          </span>
                          AM
                        </Button>
                      }
                    </ButtonGroup>
                  </Col>
                </Row>
              </ButtonToolbar>
            ) : null}

          </Col>
        </div>




      </>
    );
  }
}
export default MainVideo;
